export default function HeroSection() {
  const scrollToForm = () => {
    const formSection = document.getElementById('inscricao');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Fashion Background"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/b1e6f203c1c86f7f2e02323a22506a53.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/85"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto w-full pt-24 sm:pt-20 pb-12">
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-6 sm:mb-8">
          <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-3 sm:px-5 py-1.5 rounded-full text-xs sm:text-sm font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
            <i className="ri-calendar-event-fill text-sm"></i>
            11/03 • 19h30
          </span>
          <span className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-3 sm:px-5 py-1.5 rounded-full text-xs sm:text-sm font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
            <i className="ri-map-pin-fill text-yellow-500 text-sm"></i>
            BARRA DO BUGRES - MT
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-3 sm:mb-5 leading-tight">
          Sua Carreira na Moda, TV e
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
            Redes Sociais Começa Aqui
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-2 sm:mb-3 font-light max-w-3xl mx-auto">
          Seletiva Oficial <strong className="text-white font-semibold">Four Models</strong> em{' '}
          <strong className="text-yellow-500 font-bold">Barra do Bugres - MT</strong>
        </p>

        <p className="text-lg sm:text-xl md:text-2xl text-white mb-8 sm:mb-10 font-semibold max-w-2xl mx-auto leading-relaxed px-2">
          Descubra se você ou seu filho(a) tem perfil para moda, TV e internet.
        </p>

        <button
          onClick={scrollToForm}
          className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-10 md:px-14 py-4 sm:py-5 rounded-full text-base sm:text-lg md:text-xl font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-2xl hover:shadow-yellow-500/40 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          QUERO PARTICIPAR
        </button>

        <p className="text-yellow-500/80 text-xs sm:text-sm mt-3 sm:mt-4 font-medium">
          Inscrição gratuita • Não precisa experiência
        </p>

        <div className="mt-10 sm:mt-12 flex flex-wrap items-center justify-center gap-6 sm:gap-8 md:gap-12 text-white px-4">
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-black text-yellow-500">03–35</div>
            <div className="text-xs sm:text-sm text-gray-300 mt-1">Anos</div>
          </div>
          <div className="w-px h-10 sm:h-12 bg-gray-600"></div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-black text-yellow-500">100%</div>
            <div className="text-xs sm:text-sm text-gray-300 mt-1">Gratuito</div>
          </div>
          <div className="w-px h-10 sm:h-12 bg-gray-600"></div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-black text-yellow-500">0</div>
            <div className="text-xs sm:text-sm text-gray-300 mt-1">Experiência Necessária</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-yellow-500"></i>
      </div>
    </section>
  );
}